import GATSBY_COMPILED_MDX from "/home/runner/work/garakuta-toolbox-mirror/garakuta-toolbox-mirror/assets/posts/20230212/index.mdx";
import React, {useEffect} from "react";
import {graphql, Link} from "gatsby";
import {useLocation} from "@reach/router";
import Layout from "../layouts/default";
import * as styles from "./post.module.css";
import "./slug.css";
import TagList from "../components/TagList";
import HeadingNavLinksContainer from "../components/HeadingNavLinksContainer";
import "katex/dist/katex.min.css";
import {Helmet} from "react-helmet";
function BlogPost({data, children}) {
  const description = data.mdx.excerpt;
  const location = useLocation();
  useEffect(() => {
    import("@piyoppi/counter-button");
  });
  return React.createElement(Layout, {
    title: data.mdx.frontmatter.title,
    description: description
  }, React.createElement(HeadingNavLinksContainer, null, React.createElement(Link, {
    to: "/weblog"
  }, "< 一覧へ戻る")), React.createElement("article", {
    className: "blogArticle"
  }, React.createElement("header", null, React.createElement("h1", {
    className: styles.postTitle
  }, React.createElement("a", {
    href: location.href
  }, data.mdx.frontmatter.title)), React.createElement("div", {
    className: styles.articleSummary
  }, React.createElement(TagList, {
    tags: data.mdx.frontmatter.tags
  }), React.createElement("time", {
    dateTime: data.mdx.frontmatter.date
  }, data.mdx.frontmatter.date))), children, React.createElement("div", {
    className: styles.shareArea
  }, React.createElement(Helmet, {
    script: [{
      src: "https://platform.twitter.com/widgets.js",
      async: true
    }]
  }), React.createElement("a", {
    href: "https://twitter.com/share?ref_src=twsrc%5Etfw",
    className: "twitter-share-button",
    "data-lang": "ja",
    "data-dnt": "true",
    "data-show-count": "false"
  }, "Tweet")), React.createElement("div", {
    className: styles.counterSection
  }, React.createElement("counter-container", {
    apiurl: data.site.siteMetadata.counterUrl
  }, React.createElement("counter-increment-button", null, React.createElement("span", {
    className: styles.likeButton
  }, "🌟", React.createElement("span", {
    className: styles.likeCount
  }, React.createElement("counter-display", null, React.createElement("span", {
    slot: "loading"
  }, "..."), React.createElement("span", {
    slot: "error"
  }, "0")))))), React.createElement("div", {
    className: styles.counterNote
  }, React.createElement("p", null, "クリックすると匿名でいいねできます。"), React.createElement("p", null, "(", React.createElement("a", {
    href: "https://github.com/piyoppi/counter-tools"
  }, "@piyoppi/counter-tools"), " ", "を使っています )")))));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPost, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const query = graphql`
  query ($id: String) {
    mdx(id: { eq: $id }) {
      frontmatter {
        title
        date(formatString: "MMMM D, YYYY")
        tags
      }
      excerpt(pruneLength: 100)
    }
    site {
      siteMetadata {
        counterUrl
      }
    }
  }
`;
